import React from 'react';
import ImageSwiper from '../../UI/ImageSwiper';
import PlantButtons from '../dashboard/plants/PlantButtons';
import PlantHero from '../dashboard/plants/PlantHero';

const ArchivedPlantList = (props) => {
  if (props.isLoading) {
    return (
      <div className="container px-5 lg:px-16 py-20 mx-auto">
        <div className="flex flex-wrap -m-4 animate-pulse">
          {[...Array(4)].map((e, i) => (
            <SkeletonArchivePlant isLoggedin={props.isLoggedin} key={i} />
          ))}
        </div>
      </div>
    );
  }

  if (props.fetchedPlants.length === 0) {
    return (
      <div className="container px-5 lg:px-16 py-20 mx-auto">
        <div className="flex flex-wrap -m-4">
          <div className="mx-auto font-bold">No Gifted/Dead Plants Found!</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container px-5 lg:px-16 py-20 mx-auto">
      <div className="flex flex-wrap -m-4">
        {props.fetchedPlants.map((p) => (
          <div className="xl:w-1/4 md:w-1/2 w-full p-4" key={p.id}>
            <div className="bg-gray-100 p-6 rounded-lg">
              <ImageSwiper
                images={p.images}
                removeImage={(img) => props.removeImage(img, p)}
                isLoggedin={props.isLoggedin}
                showImages={() => props.showImages(p.images)}
              />
              <PlantHero plant={p} archived={true} />
              <PlantButtons
                plant={p}
                archived={true}
                archivePlant={props.archivePlant}
                deletePlant={props.deletePlant}
                allowDelete={props.allowDelete}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const SkeletonArchivePlant = ({ isLoggedin }) => {
  return (
    <div className="xl:w-1/4 md:w-1/2 w-full p-4">
      <div className="bg-gray-100 p-6 rounded-lg">
        <div className="h-96 rounded w-full bg-gray-200 object-cover object-center"></div>
        <div className="mt-4">
          <div className="w-14 h-4 bg-gray-200 rounded-full"></div>
          <div className="w-28 h-7 bg-gray-200 rounded-full mt-1"></div>
          <div className="w-14 h-[1.625rem] bg-gray-200 rounded-full "></div>
          <div className="w-32 h-[1.625rem] bg-gray-200 rounded-full mt-4"></div>
        </div>
        {isLoggedin && (
          <div className="w-12 bg-gray-200 rounded-full h-5 mt-3"></div>
        )}
      </div>
    </div>
  );
};

export default ArchivedPlantList;
